(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const shipDate = () => {
    const els = document.querySelectorAll('[data-hv-shipdate]');
    if (!els.length) return;
    const et = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const biz = (d) => d.getDay() !== 0 && d.getDay() !== 6;
    const start = new Date(et);
    if (!biz(start) || start.getHours() >= 16) {
      do start.setDate(start.getDate() + 1);
      while (!biz(start));
    }
    const ship = new Date(start);
    let left = 2;
    while (left > 0) {
      ship.setDate(ship.getDate() + 1);
      if (biz(ship)) left--;
    }
    const label = ship.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    els.forEach((el) => {
      el.textContent = '';
      el.append('Ships by ');
      const b = document.createElement('strong');
      b.textContent = label;
      el.append(b);
    });
  };

  const pagesOf = (comp) => {
    const slider = comp.querySelector('.slider');
    if (!slider) return { slider: null, items: [], total: 0, step: 0 };
    const items = [...slider.querySelectorAll(':scope > .slider__slide, :scope > .grid__item')].filter((el) => el.offsetParent !== null);
    if (items.length < 2) return { slider, items, total: items.length, step: 0 };
    const step = items[1].offsetLeft - items[0].offsetLeft;
    const perView = Math.max(1, Math.round((slider.clientWidth + 1) / step));
    return { slider, items, step, total: Math.max(1, items.length - perView + 1) };
  };

  const setupDots = (comp) => {
    if (comp.dataset.hvDots || /^GalleryThumbnails/.test(comp.id || '')) return;
    const buttons = comp.querySelector('.slider-buttons');
    if (!buttons) return;
    comp.dataset.hvDots = '1';
    const dots = document.createElement('div');
    dots.className = 'hv-dots';
    const next = buttons.querySelector('.slider-button--next');
    if (next) buttons.insertBefore(dots, next);
    else buttons.appendChild(dots);
    const build = () => {
      const { slider, total, step } = pagesOf(comp);
      dots.innerHTML = '';
      if (!slider || total < 2 || !mobile.matches) return;
      for (let i = 0; i < total; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `${i + 1} / ${total}`);
        b.addEventListener('click', () => slider.scrollTo({ left: step * i, behavior: reduce.matches ? 'auto' : 'smooth' }));
        dots.appendChild(b);
      }
      mark();
    };
    const mark = () => {
      const { slider, step } = pagesOf(comp);
      if (!slider || !step) return;
      const cur = Math.round(slider.scrollLeft / step);
      [...dots.children].forEach((b, k) => b.setAttribute('aria-current', k === cur ? 'true' : 'false'));
    };
    const slider = comp.querySelector('.slider');
    if (slider) slider.addEventListener('scroll', () => window.requestAnimationFrame(mark), { passive: true });
    comp.addEventListener('slideChanged', mark);
    window.addEventListener('resize', build);
    mobile.addEventListener('change', build);
    build();
  };

  const initDots = (scope) => {
    scope.querySelectorAll('.collection slider-component, .product__media-wrapper slider-component').forEach(setupDots);
  };

  const toTop = () => {
    if (document.querySelector('.hv-totop')) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'hv-totop';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true"><path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z"/></svg>';
    b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' }));
    document.body.appendChild(b);
    const sync = () => b.classList.toggle('is-visible', window.scrollY > 400);
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  };

  const init = (scope) => {
    shipDate();
    initDots(scope);
  };

  const start = () => {
    init(document);
    toTop();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => init(document), 60));
  }
})();
